import { css } from "@emotion/react";
import type { PropsWithChildren } from "react";

import { type Action, getActionAnchorProps, getActionClickableProps } from "./Action";

type LinkProps = PropsWithChildren<{
    action?: Action | undefined;
    className?: string;
}>;

export default function Link(props: LinkProps) {
    const { action, children, className } = props;
    const anchorProps = getActionAnchorProps(action);
    const clickableProps = getActionClickableProps(action);

    const containerCss = css({
        display: "block",
    });

    return (
        <a css={containerCss} {...anchorProps} {...clickableProps} className={className}>
            {children}
        </a>
    );
}
